import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig'; 
import { collection, query, where, getDocs } from 'firebase/firestore';
import BookNow from './BookNow'; 

const TouristSpotDetails = () => {
    const { countryName, spotName } = useParams();
    const navigate = useNavigate();

    const [spot, setSpot] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isBookingOpen, setIsBookingOpen] = useState(false);

    // Exchange Rate (You can fetch this dynamically, but hardcoding for now is fine)
    const EXCHANGE_RATE = 129; // Approx 1 USD = 129 KES

    useEffect(() => {
        const fetchDetails = async () => {
            setLoading(true);
            try {
                // 1. Find Country ID (Use Name as ID logic if you updated the seed script, 
                // OR use Query logic if you kept random IDs. Keeping Query logic for safety)
                const countryQ = query(collection(db, "countries"), where("name", "==", countryName));
                const countrySnapshot = await getDocs(countryQ);

                if (countrySnapshot.empty) { setError("Country not found"); setLoading(false); return; }

                const countryId = countrySnapshot.docs[0].id;

                // 2. Find Spot Details
                const spotsRef = collection(db, "countries", countryId, "touristSpots");
                const spotQ = query(spotsRef, where("name", "==", spotName));
                const spotSnapshot = await getDocs(spotQ);

                if (spotSnapshot.empty) { setError("Spot not found"); } 
                else { setSpot(spotSnapshot.docs[0].data()); }
                
                setLoading(false);
            } catch (err) { setError("Error loading details."); setLoading(false); }
        };
        fetchDetails();
    }, [countryName, spotName]);

    if (loading) return <h2 style={{textAlign:'center', marginTop:'50px'}}>Loading...</h2>;
    if (!spot) return <h2 style={{textAlign:'center', marginTop:'50px'}}>Details not found</h2>;

    // --- CURRENCY FORMATTING LOGIC ---
    const usdCost = Number(spot.cost); // Ensure it's a number
    const kesCost = usdCost * EXCHANGE_RATE;
    
    // Format with commas (e.g., 1,000)
    const formattedUSD = usdCost.toLocaleString(); 
    const formattedKES = kesCost.toLocaleString();

    return (
        <div className="details-container">
            <div className="details-header">
                <button onClick={() => navigate(-1)} className="details-back-button">Back</button>
                <h2>{spot.name}</h2>
            </div>
            
            {/* Fallback image logic included */}
            <img 
                src={spot.image || 'https://via.placeholder.com/800x400'} 
                alt={spot.name} 
                className="details-image" 
                style={{width:'100%', maxHeight:'500px', objectFit:'cover', borderRadius:'10px'}} 
                onError={(e) => {e.target.src='https://via.placeholder.com/800x400?text=Image+Not+Found'}}
            />
            
            <div style={{ marginTop: '30px', maxWidth: '800px', margin: '30px auto', textAlign: 'left', padding: '0 20px' }}>
                <p style={{fontSize: '1.1rem', marginBottom: '10px'}}><strong>Location:</strong> {spot.location}</p>
                <p style={{fontSize: '1.1rem', marginBottom: '10px'}}><strong>Distance:</strong> {spot.distance}</p>
                
                {/* --- PRICE DISPLAY FIXED --- */}
                {spot.cost && (
                    <p style={{fontSize: '1.2rem', marginBottom: '10px', color: '#2c3e50'}}>
                        <strong>Estimated Cost:</strong> 
                        <span style={{color: '#27ae60', fontWeight: 'bold', marginLeft: '5px'}}>
                             ${formattedUSD} USD 
                        </span>
                        <span style={{margin: '0 10px', color: '#ccc'}}>|</span>
                        <span style={{color: '#27ae60', fontWeight: 'bold'}}>
                             KES {formattedKES}
                        </span>
                    </p>
                )}
                
                <div style={{margin: '20px 0', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', borderLeft: '5px solid  #2f4f4f'}}>
                    <p style={{fontStyle: 'italic', fontSize: '1.2rem'}}>"{spot.message}"</p>
                </div>
                
                {spot.popularity && <p><strong>Why it's popular:</strong> {spot.popularity}</p>}

                <button 
                    onClick={() => setIsBookingOpen(true)}
                    style={{
                        backgroundColor: ' #2f4f4f', color: 'white', padding: '15px 40px', border: 'none', borderRadius: '30px',
                        fontSize: '18px', cursor: 'pointer', fontWeight: 'bold', marginTop: '20px', display: 'block', width: '100%'
                    }}
                >
                    Book This Trip
                </button>
            </div>

            {isBookingOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div style={{backgroundColor: 'white', padding: '20px', borderRadius: '10px', maxHeight: '90vh', overflowY: 'auto', width: '90%', maxWidth: '500px', position: 'relative'}}>
                        <button onClick={() => setIsBookingOpen(false)} style={{position: 'absolute', top: '10px', right: '10px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer'}}>X</button>
                        <BookNow initialDestination={spot.name} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default TouristSpotDetails;